// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Background_wrapper__1F-As"};